<script>
import BaseContainer from "./BaseContainer.vue";
export default {
  extends: BaseContainer,
  data() {
    return {
      position: "header",
      allow: ["image", "video", "text", "image-text"]
    };
  }
};
</script>
